import React, { useContext, useEffect, useRef, useState } from 'react'
import Fab from '@mui/material/Fab';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, InputAdornment, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import { chatbotServices } from 'src/services/chatbot/chatbot.service';
import { useNotify, useTranslate } from 'react-admin';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import betoIcon from '../../../assets/chatbot/beto.png';
import { ChatbotContext } from './ChatbotContext';
import ReactMarkdown from 'react-markdown'
import RemoveIcon from '@mui/icons-material/Remove';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';

const ContractedText = ({chatIdx, setChats, chat}) =>{
    const translate = useTranslate()
    const MAX_CHARS = 300
    const [showText, setShowText] = useState(chat.answer)
    const [isContracted, setIsContracted] = useState(false)
    const [isContractExpanded, setIsContractExpanded] = useState(false)
    const [feedback, setFeedback] = useState(chat.feedback ?? null)

    const onSetFeedBack = (feedback) =>{
        setFeedback(feedback)
        setChats(chats=>{
            const newChats = chats.map((chat,i)=>
                i === chatIdx ?
                {...chat, feedback} :
                chat
            )
            localStorage.setItem('chats',JSON.stringify(newChats))
            return newChats
        })
        if(feedback === false){
            chatbotServices.sendFeedbackMail(chat)
        }
    }

    useEffect(()=>{
        if(chat.answer.length > MAX_CHARS){
            setIsContracted(true)
            setShowText(chat.answer.slice(0, MAX_CHARS))
        } else {
            setShowText(chat.answer)
        }
    },[])

    const onExpand = () =>{
        setShowText(chat.answer)
        setIsContractExpanded(true)
    }

    const onContract = () =>{
        setShowText(chat.answer.slice(0, MAX_CHARS))
        setIsContractExpanded(false)
    }

    const decodeUnicode = (str) => {
        return str
        // convierte \uXXXX → carácter
        .replace(/\\u([\dA-Fa-f]{4})/g, (_, g1) => String.fromCharCode(parseInt(g1, 16)))
        // convierte \n → salto de línea real
        .replace(/\\n/g, '\n')
        // convierte \t → tab real
        .replace(/\\t/g, '\t');
    }

    return(
        <>
            <div>
                <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                    <img loading="lazy" src={betoIcon} style={{marginRight:'10px'}} alt="Icono" width={22} />
                    <label style={{fontWeight:'bold'}}>{'Beto'}</label>
                </div>
                {/* <div 
                    style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}
                    dangerouslySetInnerHTML={{ __html: showText }}    
                /> */}
                <div 
                    style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}
                    
                >
                    <ReactMarkdown
                        components={{
                            p: ({ node, ...props }) => (
                            <p style={{ marginTop: 10, marginBottom: 2.5, lineHeight: 1.5 }} {...props} />
                            ),
                            ol: ({ node, ...props }) => (
                            <ol
                                style={{
                                marginTop: 0,
                                marginBottom: 0,
                                paddingLeft: '1.5em',
                                lineHeight: 0.5,
                                }}
                                {...props}
                            />
                            ),
                            ul: ({ node, ...props }) => (
                            <ul
                                style={{
                                marginTop: 0,
                                marginBottom: 0,
                                paddingLeft: '1.5em',
                                lineHeight: 0.5,
                                }}
                                {...props}
                            />
                            ),
                            li: ({ node, ...props }) => (
                            <li
                                style={{
                                marginTop: 0,
                                marginBottom: 0,
                                paddingTop: 0,
                                paddingBottom: 0,
                                lineHeight: 1.5,
                                }}
                                {...props}
                            />
                            ),
                        }}
                    >
                        {decodeUnicode(showText)}
                    </ReactMarkdown>
                </div>
            </div>
            {isContracted &&
                (
                    isContractExpanded ? 
                    <div style={{color:'#1565c0', display:'flex', flexDirection:'row', cursor:'pointer'}}
                        onClick={onContract}
                    >
                        {translate('ra.action.see_less')}
                        <KeyboardArrowUpIcon/>
                    </div>
                    :
                    <div style={{color:'#1565c0', display:'flex', flexDirection:'row', cursor:'pointer'}}
                        onClick={onExpand}
                    >
                        {translate('ra.action.see_more')}
                        <KeyboardArrowDownIcon/>
                    </div>
                )
            }
            <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                {
                    feedback === true ?
                    <ThumbUpAltIcon color='primary' style={{cursor:'pointer', marginRight:'5px'}} fontSize='small'/> :
                    <ThumbUpOffAltIcon onClick={()=>feedback === null && onSetFeedBack(true)} color='primary' style={{cursor:'pointer', marginRight:'5px'}} fontSize='small'/>
                }
                {
                    feedback === false ?
                    <ThumbDownAltIcon color='primary' style={{cursor:'pointer'}} fontSize='small'/> :
                    <ThumbDownOffAltIcon onClick={()=>feedback === null && onSetFeedBack(false)} color='primary' style={{cursor:'pointer'}} fontSize='small' />
                }    
        
            </div>

        </>
    )
}

export const ChatButton = () => {
    const translate = useTranslate()
    const notify = useNotify()
    const [openChat, setOpenChat] = useState(false)
    const [question, setQuestion] = useState('')
    const [iaProcessing, setIaProcessing] = useState(false)
    const [chats, setChats] = useState([])
    const [isExpanded, setIsExpanded] = useState(false)
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
    const {showFabChat, setShowFabChat, chatPosition, setChatPosition} = useContext(ChatbotContext);
    /* const [position, setPosition] = useState({ x: 0, y: 0 }); */
    const [dragging, setDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [moved, setMoved] = useState(false);
    const [start, setStart] = useState(null);
    const fabRef = useRef(null);
    const divRef = useRef(null);
    const localSize = localStorage.getItem('chatSize') ? JSON.parse(localStorage.getItem('chatSize')) :null
    const localExpandedSize = localStorage.getItem('expandedChatSize') ? JSON.parse(localStorage.getItem('expandedChatSize')) :null
    const tempSize = useRef({ width: 0, height: 0 });

    useEffect(()=>{
        if(!divRef.current)
            return
        const observer = new ResizeObserver(entries => {
            const { width, height } = entries[0].contentRect;
            tempSize.current = { width, height }; 
        });
        
        observer.observe(divRef.current);
        const handlePointerUp = () => {
            if(isExpanded){
                localStorage.setItem('expandedChatSize',JSON.stringify(tempSize.current))
            } else {
                localStorage.setItem('chatSize',JSON.stringify(tempSize.current))
            }
           
        };

        window.addEventListener("mouseup", handlePointerUp);

        return () => {
            observer.disconnect();
            window.removeEventListener("mouseup", handlePointerUp);
        };
    },[openChat,isExpanded])

    useEffect(()=>{
        const localChats = localStorage.getItem('chats')
        const isReseted = JSON.parse(localStorage.getItem('resetChats'))
        if(!isReseted){
            localStorage.removeItem('chats')
            localStorage.setItem('resetChats',JSON.stringify(true))
        }
        else if(localChats && isReseted){
            const parsedChats = JSON.parse(localChats)
            setChats(parsedChats)
        }
        
    },[])

    useEffect(() => {
        const savedPosition = JSON.parse(localStorage.getItem("fabPosition"));
        const setInitialPosition = () => {
            const fab = fabRef.current;
            const fabWidth = fab?.offsetWidth || 60;
            const fabHeight = fab?.offsetHeight || 60;
            
            if (savedPosition) {
                setChatPosition(savedPosition);
                } else {
                // posición por defecto (20px desde abajo y 200px desde la derecha)
                setChatPosition({
                    x: 50,
                    y: 20,
                });
            }
        };

        setInitialPosition();
        window.addEventListener("resize", setInitialPosition);
        return () => window.removeEventListener("resize", setInitialPosition);
    }, []);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!dragging) return;

            const dx = Math.abs(e.clientX - start.x);
            const dy = Math.abs(e.clientY - start.y);
            if (dx > 5 || dy > 5) setMoved(true);

            if (moved) {
            const fab = fabRef.current;
            const fabWidth = fab?.offsetWidth || 60;
            const fabHeight = fab?.offsetHeight || 60;

            setChatPosition({
                x: window.innerWidth - (e.clientX + (fabWidth - offset.x)),
                y: window.innerHeight - (e.clientY + (fabHeight - offset.y)),
            });
            }
        };

        const handleMouseUp = (e) => {
            const fab = fabRef.current;
            const fabWidth = fab?.offsetWidth || 60;
            const fabHeight = fab?.offsetHeight || 60;

            const right = window.innerWidth - (e.clientX + (fabWidth - offset.x));
            const bottom = window.innerHeight - (e.clientY + (fabHeight - offset.y));

            localStorage.setItem("fabPosition", JSON.stringify({ x:right, y:bottom }));
            setDragging(false);
        };

        // Escuchar globalmente mientras se arrastra
        if (dragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        }

        // Limpiar al soltar
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [dragging, moved, offset, start]);

    const handleMouseDown = (e) => {
        setDragging(true);
        setMoved(false);

        const fab = fabRef.current;
        const fabWidth = fab?.offsetWidth || 60;
        const fabHeight = fab?.offsetHeight || 60;

        setStart({ x: e.clientX, y: e.clientY });

        // calcular offset desde el borde derecho e inferior
        setOffset({
            x: fabWidth - (window.innerWidth - e.clientX - chatPosition.x),
            y: fabHeight - (window.innerHeight - e.clientY - chatPosition.y),
        });

        e.preventDefault();
    };

    const handleClick = () => {
        if (!moved) {
            setOpenChat(true)
        }
    };

    const onDeleteChat = () =>{
        localStorage.removeItem('chats')
        setChats([])
        setOpenConfirmDelete(false)
    }
    
    const askBot = async () =>{
        if(question){
            setIaProcessing(true)
            let formattedChats = []
            for (let i = Math.max(0, chats.length - 6); i < chats.length; i++) {
                formattedChats.push(chats[i].question)
                formattedChats.push(chats[i].answer)
            }
            await chatbotServices.askBot(question, formattedChats).then((res)=>{
                let newChats = [...chats]
                if(!res){
                    notify('ra.notification.send_question_error',{type:'error'})
                    return
                }
                if(res.knows === false){
                    chatbotServices.promptNotFound(question)
                }
                newChats.push({question:question, answer:res.answer})
                setChats(newChats)
                localStorage.setItem('chats', JSON.stringify(newChats));
                setQuestion('')
            }).catch(()=>{
                notify('ra.notification.send_question_error',{type:'error'})
            }).finally(()=>{
                setIaProcessing(false)
            })
        }
    }

    const deleteChats = () =>{
        setOpenConfirmDelete(true)
    }

    const onClose = () =>{
        localStorage.removeItem('chatSize')
        localStorage.removeItem('expandedChatSize')
        setOpenChat(false)
        setShowFabChat(false)
        setIsExpanded(false)
    }

    const onMinimize = () =>{
        setOpenChat(false)
        setIsExpanded(false)
    }

    return (
        <>
            {(openChat && showFabChat) &&
            <div
                ref={divRef}
                style={{
                    resize: "both",
                    overflow: 'hidden',
                    minWidth: "270px",
                    minHeight:"420px",
                    position:'fixed', 
                    height:isExpanded ? localExpandedSize ? localExpandedSize.height:
                        '95%':
                        localSize ? localSize.height:
                        '90%',
                    width:isExpanded? localExpandedSize ? localExpandedSize.width:
                        '60%':
                        localSize? localSize.width:
                        '30%',
                    borderTopLeftRadius:'15px',
                    borderTopRightRadius:'15px',
                    backgroundColor:'white',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                    zIndex: 9999,

                    right: chatPosition.x,//isExpanded ? chatPosition.x - 400 : chatPosition.x,
                    bottom:chatPosition.y, //isExpanded ? chatPosition.y - 230: chatPosition.y - 200,
                }}
            >
                <div 
                    ref={fabRef}
                    onMouseDown={handleMouseDown}
                    style={{
                        height:'7%', 
                        display:'flex', 
                        flexDirection:'row', 
                        width:'100%',
                        justifyContent:'space-between', 
                        alignItems:'center',
                        backgroundColor:'#4b4bf5ff',
                        borderTopLeftRadius:'15px',
                        borderTopRightRadius:'15px',
                        cursor: dragging ? "grabbing" : "grab",
                        transition: dragging ? "none" : "transform 0.2s ease",
                        padding:'15px'
                        }}>
                    <div style={{color:'white', fontWeight:'bold', alignItems:'center', display:'flex', flexDirection:'row'}}>
                        <img loading="lazy" src={betoIcon} style={{marginRight:'10px'}} alt="Icono" width={22} />
                        {'Beto'}
                    </div>
                    <div>
                        <DeleteSweepIcon style={{cursor:'pointer', color:'white',marginLeft:'15px'}} onClick={deleteChats}/>
                        <RemoveIcon style={{cursor:'pointer', color:'white',marginLeft:'15px'}} onClick={onMinimize}/>
                        {
                            isExpanded ?
                            <CloseFullscreenIcon onClick={()=>setIsExpanded(!isExpanded)} style={{cursor:'pointer', color:'white', marginLeft:'15px'}}/>:
                            <OpenInFullIcon onClick={()=>setIsExpanded(!isExpanded)} style={{cursor:'pointer', color:'white', marginLeft:'15px'}}/>
                        }
                        <CloseIcon style={{cursor:'pointer', color:'white',marginLeft:'15px'}} onClick={onClose}/>
                    </div>
                </div>
                {chats.length === 0 ? 
                    <Box
                        sx={{
                            height:'68%',
                            textAlign:'center',
                            display:'flex',
                            flexDirection:'column',
                            overflowY: 'auto',
                            alignItems:'center',
                            padding:'35px',
                            margin:'15px'
                        }}
                    >
                        <label style={{fontWeight:'bold', marginBottom:'20px'}}>
                            {'Hola, soy Beto, ¡el Capitán de este espacio!'}
                        </label>
                        <label>
                            {'Soy tu compañero de viaje en B2: te ayudo a explorar sus funciones, resolver tus dudas y encontrar lo que buscás. ¿Arrancamos?'}
                        </label>
                    </Box>:
                    <Box
                        ref={(el) => {
                            if (el) {
                                el.scrollTo({
                                    top: el.scrollHeight,
                                    behavior: "smooth",
                                });
                            }
                        }}
                        sx={{
                            height:'68%',
                            display:'flex',
                            flexDirection:'column',
                            overflowY: 'auto',
                            margin:'15px'
                        }}
                    >{chats.map((chat, idx)=>(
                    <div style={{display:'flex', flexDirection:'column'}} key={idx}>
                       <div 
                        style={{
                            width:'70%', 
                            height:'auto',
                            backgroundColor:'lightgray', 
                            alignSelf:'flex-end',
                            borderTopRightRadius:'10px',
                            borderTopLeftRadius:'10px',
                            borderBottomLeftRadius:'10px',
                            padding:'10px'
                        }}>
                            {
                                chat.question.split('\n').map((block, i)=>(
                                    <div key={i}>
                                        {block}
                                    </div>
                                ))
                            }
                        </div>

                        <div 
                        style={{
                            width:'70%', 
                            marginTop:'15px',
                            height:'auto',
                            textAlign:'start',
                            alignSelf:'flex-start',
                            borderTopRightRadius:'10px',
                            borderTopLeftRadius:'10px',
                            borderBottomLeftRadius:'10px',
                            padding:'10px',
                        }}>
                            <ContractedText chatIdx = {idx} setChats={setChats} chat={chat}/>
                        </div>
                    </div>
                    ))}
                    </Box>
                
                }
                <div style={{height:'17%', display:'flex', margin:'15px'}} onMouseDown={(e) => e.stopPropagation()}>
                    <TextField 
                        fullWidth
                        multiline
                        disabled={iaProcessing}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                askBot();
                            }
                        }}
                        value={question}
                        onChange={(val)=>{
                            if(val.target.value?.length === 1000){
                                console.log("entraa a max")
                                notify('ra.notification.max_chars_prompt', {type:'error'})
                            }
                            setQuestion(val.target.value)
                        }}
                        sx={{
                            flex: 1,
                            "& .MuiInputBase-root": {
                                height: "100%",
                                alignItems: "flex-start", // para multiline
                            },
                            "& .MuiInputBase-inputMultiline": {
                                height: "100% !important",
                                overflow: "auto",
                            },
                        }}
                        inputProps={{
                            maxLength:1000
                        }}
                        InputProps={{
                            endAdornment: (
                            <InputAdornment position="end">
                                {
                                iaProcessing ? 
                                    <CircularProgress edge="end"
                                        sx={{ 
                                            position: "absolute",
                                            right: 15,
                                            bottom: 8,
                                            color: "#1565c0"
                                        }}/>:
                                    <IconButton
                                        onClick={async(e)=>{e.stopPropagation();await askBot()}}
                                        edge="end"
                                        sx={{ 
                                            position: "absolute",
                                            right: 15,
                                            bottom: 8,
                                            color: "#1565c0"
                                        }}
                                    >
                                        <SendIcon />
                                    </IconButton>
                                }
                            </InputAdornment>
                            ),
                        }}
                        label={'Escribí tu pregunta...'}
                    />
                </div>
            </div>}
            {(!openChat && showFabChat) &&

            <Fab 
                color="primary" 
                aria-label="add" 
                ref={fabRef}
                onMouseDown={handleMouseDown}
                style={{
                    position: "fixed",
                    right: chatPosition.x,
                    bottom: chatPosition.y,
                    cursor: dragging ? "grabbing" : "grab",
                    transition: dragging ? "none" : "transform 0.2s ease",
                    width:'auto',
                    alignItems:'center',
                    padding:'10px',
                    borderRadius:'15px',
                    backgroundColor:'#4b4bf5ff',
                    textTransform: 'none' 
                }}
                onClick={handleClick}
            >
                <img loading="lazy" src={betoIcon} style={{marginRight:'10px'}} alt="Icono" width={22} />
                {'Preguntale a Beto'}
                <CloseIcon 
                    onClick={(e)=>{
                        e.stopPropagation();
                        setShowFabChat(false)
                    }} 
                    style={{alignSelf:'start', width:'15px', marginLeft:'15px'}}
                />
            </Fab>
            }
            {/* <ConfirmationDialog
                title={translate('ra.message.delete_chat_bot')}
                buttonConfirmText={translate('ra.action.to_confirm')}
                buttonCancel={translate('ra.action.cancel')}
                setOpen={setOpenConfirmDelete}
                setConfirm={setConfirmDeleteChat}
                open={openConfirmDelete}
            /> */}
            <Dialog
                open = {openConfirmDelete}
                onClose={()=>setOpenConfirmDelete(false)}
            >
                <DialogTitle style={{fontWeight:'bold'}}>
                    {translate('ra.title.confirm_action')}
                </DialogTitle>
                <DialogContent>
                    <p>
                        {translate('ra.message.delete_chat_bot')}
                    </p>
                    <div style={{display:'flex', flexDirection:'row'}}>
                        <Button
                            variant='outlined'
                            style={{borderStyle:'none', backgroundColor:'white', fontWeight:'bold'}}
                            onClick={()=>setOpenConfirmDelete(false)}
                        >
                            {translate('ra.action.cancel')}
                        </Button>
                        <Button
                            variant='contained'
                            style={{fontWeight:'bold'}}
                            onClick={onDeleteChat}
                        >
                            {translate('ra.message.confirm_delete')}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}
